// 👉 Paste images Public/partner_images folder ONLY
const partners = [
    "hdfc.webp",
    "icici.webp",
    "bajaj.webp",
    "reliance.webp",
    "digit.webp",
    "liberty.webp",
    "aditya.webp",
    "manipal.webp",
    "star.webp",
    "all_logos.webp",
    "computer_logos.webp",
    "cpplus.webp",
    "dell.webp",
    "hikvission.webp",
    "hp.webp",
    "printer_logos.webp",

];

// 👉 add more images name here ONLY

export default partners;
